import { isNotNullOrUndefined } from '@vy/utils';
import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { formatDate } from '../../../../../utils/date';

type ContractDateFieldProps = {
  label: string;
  value: Date | undefined;
};

export const ContractDateField: FC<ContractDateFieldProps> = ({ label, value }) => {
  return (
    <Stack spacing="6px">
      <Typography
        variant="body2"
        sx={{ color: 'rgba(27, 61, 85, 0.6)', fontSize: '14px', fontWeight: 400, lineHeight: '20px' }}
      >
        {label}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: 'rgba(13, 27, 39, 0.87)',
          paddingTop: '6px',
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '20px',
        }}
      >
        {isNotNullOrUndefined(value) ? formatDate(value) : 'N/A'}
      </Typography>
    </Stack>
  );
};
